// @ts-nocheck
import * as React from 'react';
import Avatar from '../components/common/Avatar';
import StatusDot from '../components/common/StatusDot';
import SourceBadge from '../components/common/SourceBadge';
import Icon from '../components/common/Icon';
import FeatureDemoCards from './FeatureDemoCards';
import './Workbench.css';

export default function Workbench({ parent, ranked, demos, onTrigger, aiOn }) {
  // top pillar = AI's recommendation
  const topPick = ranked[0];

  return (
    <section className="A-col A-col--bench">
      {/* Parent context header */}
      <div className="A-bench-head">
        <div className="A-bench-parent">
          <Avatar p={parent} size={56} />
          <div className="A-bench-parent__meta">
            <div className="A-bench-parent__top">
              <h2 className="A-bench-parent__name">{parent.name}</h2>
              <StatusDot status={parent.status} />
            </div>
            <div className="A-bench-parent__line">
              <span>{parent.child} · {parent.grade} · age {parent.childAge}</span>
              <span className="A-dot">·</span>
              <SourceBadge source={parent.source} />
              <span className="A-dot">·</span>
              <span>{parent.enquired}</span>
            </div>
            <div className="A-bench-parent__phone">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 16.9v3a2 2 0 0 1-2.2 2 19 19 0 0 1-8.6-3.1 19 19 0 0 1-6-6A19 19 0 0 1 2.1 4.2 2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1.9.3 1.8.6 2.6a2 2 0 0 1-.5 2.1L7.9 9.7a16 16 0 0 0 6 6l1.3-1.3a2 2 0 0 1 2.1-.5c.8.3 1.7.5 2.6.6a2 2 0 0 1 1.7 2.4z"/></svg>
              {parent.phone}
              <span className="A-dot">·</span>
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="9"/><line x1="3" y1="12" x2="21" y2="12"/><path d="M12 3a14 14 0 0 1 0 18M12 3a14 14 0 0 0 0 18"/></svg>
              Prefers {parent.language}
            </div>
          </div>
        </div>
        <div className="A-bench-quick">
          <button className="A-quick-btn" title="Call parent">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 16.9v3a2 2 0 0 1-2.2 2 19 19 0 0 1-8.6-3.1 19 19 0 0 1-6-6A19 19 0 0 1 2.1 4.2 2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1.9.3 1.8.6 2.6a2 2 0 0 1-.5 2.1L7.9 9.7a16 16 0 0 0 6 6l1.3-1.3a2 2 0 0 1 2.1-.5c.8.3 1.7.5 2.6.6a2 2 0 0 1 1.7 2.4z"/></svg>
            Call
          </button>
          <button className="A-quick-btn" title="Schedule visit">
            <Icon name="calendar" size={13} />
            Visit
          </button>
          <button className="A-quick-btn" title="More">⋯</button>
        </div>
      </div>

      {/* AI brief */}
      {aiOn && (
        <div className="A-ai-brief">
          <div className="A-ai-brief__head">
            <Icon name="sparkles" size={14} />
            <span className="eyebrow" style={{ color: "var(--blue)" }}>AI Counsellor Brief</span>
            <span className="A-ai-brief__score">Match {topPick.relevance}%</span>
          </div>
          <p className="A-ai-brief__body">
            <strong>{parent.concern}</strong> Lead with <strong style={{ color: topPick.color }}>{topPick.name}</strong> — it directly addresses {topPick.hits > 0 ? topPick.ranks.filter(r => parent.tags.includes(r)).slice(0,2).join(" and ") : "the family's profile"}. Pair with <strong>{ranked[1].name}</strong> if conversation runs long.
          </p>
        </div>
      )}

      {/* AI Feature Recommendation list */}
      <div className="A-feat-head" style={{ marginTop: 24, marginBottom: 12 }}>
        <span className="eyebrow eyebrow--mute">AI Features · Ranked for this family</span>
        <span style={{ fontSize: 11, color: "var(--fg-tertiary)", marginLeft: "auto" }}>Click any to trigger live demo</span>
      </div>
      <FeatureDemoCards ranked={ranked} demos={demos} onTrigger={onTrigger} aiOn={aiOn} content={parent.content} />
    </section>
  );
}
